export const levelData = {
  Volume: [79, 80, 65, 43, 82, 105],
  Service: [78, 77, 92, 114, 75, 52],
};
